<template>
  <div class="logo" @click="onHome">
    <img src="/logo.png" class="logo-image" alt="" />
    <span class="logo-title">智云<span style="font-size: 12px; margin-left: 2px; font-style: italic">一站式DevOps平台</span></span>
  </div>
</template>

<script>
export default {
  methods: {
    onHome() {
      this.$router.push('/');
    }
  }
};
</script>

<style lang="less" scoped>
.logo {
  height: 48px;
  width: 200px;
  line-height: 48px;
  cursor: pointer;
  .logo-image {
    margin-top: 8px;
    width: 32px;
    height: 32px;
    float: left;
  }
  .logo-title {
    display: block;
    margin-left: 4px;
    font-size: 18px;
    font-weight: bold;
    line-height: 48px;
    float: left;
    padding-top: 2px;
  }
}
</style>
